const initState = { credentials: null };

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "SIGNIN_SUCCESS":
      return {
        ...state,
        credentials: action.payload,
      };
    case "SIGNOUT":
      return {
        ...state,
        credentials: null,
      };
    case "UPDATE_INFO":
      return {
        ...state,
        credentials: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
